import { FormControl } from "@angular/forms";
import { MetadataPutEnum } from "@models/enums/metadata-put-enum";
import { FormBase } from "@models/portal/users/form-base";
import { IStateDto } from "@models/state-dto";

export class StatesPostForm extends FormBase{

    paiNrId:number | null;
    estTxDescricao:string | null;
    estTxSigla:string | null;

    constructor(form:StatesPostFormFg){
        super();
        this.paiNrId = form.paiNrId.value;
        this.estTxDescricao = form.estTxDescricao.value;
        this.estTxSigla = form.estTxSigla.value;

    }

    verifyChanges(current:IStateDto){
        let modified = false;
        this.entNrId = current.estNrId;
        if(
            this.estTxDescricao !== current.estTxDescricao || 
            this.estTxSigla !== current.estTxSigla ||
            this.paiNrId !== current.estObjPais.paiNrId
        ) modified = true;

        if(modified){
            this.entTxMetadado = MetadataPutEnum.ALTERADO;
        }
        else{
            this.entTxMetadado = MetadataPutEnum.INALTERADO;
        }
    }
}

export interface StatesPostFormFg {
    paiNrId:FormControl<number | null>,
    estTxDescricao:FormControl<string | null>,
    estTxSigla:FormControl<string | null>
}